'use client';

import {DEFAULT_LOCALE, isLocale, localeHref} from '@olympus-frontend/core/i18n';
import {NotFoundPage} from '@olympus-frontend/core/pages/not-found';
import {useParams} from 'next/navigation';
import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

// Route-level error boundary for all localized pages. Renders inside the
// [locale] layout, so it keeps the theme/i18n providers and reuses the same
// content as the not-found page. error boundaries get no params, so the locale
// comes from useParams; strings come from the layout's I18nProvider (see not-found.tsx).
export default function LocaleError({error}: {error: Error & {digest?: string}}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  const params = useParams<{locale: string}>();
  const locale = isLocale(params.locale) ? params.locale : DEFAULT_LOCALE;
  const {t} = useTranslation();

  return (
    <NotFoundPage
      title={t('page_not_found_title')}
      body={t('page_not_found_body')}
      ctaLabel={t('go_to_hompage')}
      ctaHref={localeHref(locale)}
      illustrationSrc="/not-found.svg"
    />
  );
}
